import { AccessibilityContext } from '@app/app/_context/AccessibilityContext/AccessibilityContext';
import { useContext } from 'react';

export function useFontSize(): string {
    const { fontSize } = useContext(AccessibilityContext);
    return fontSize;
}
